import React, { PureComponent } from 'react';
import './BasketBar.scss';
import { BasketBanner } from 'components';
import { SofaCartIcon } from '@sofology/sofologycomponents';

const bannerConfig = {
    headerText: 'Questions about your order?',
    text: 'Call us FREE on ',
    phone: '0800 140 4040'
};

const BASKET_TITLE = 'Your basket';

interface OwnProps {
    cartItemsCount: number;
    loading: boolean;
}

export class BasketBar extends PureComponent<OwnProps> {
    render(): JSX.Element {
        const { cartItemsCount, loading } = this.props;

        return (
            <div className='basket-bar-wrapper'>
                <div className='basket-bar'>
                    <div className='basket-bar__item'>
                        <SofaCartIcon itemsCount={cartItemsCount} title={BASKET_TITLE} loading={loading} />
                    </div>
                    <div className='basket-bar__item'>
                        <BasketBanner
                            headerText={bannerConfig.headerText}
                            text={bannerConfig.text}
                            phone={bannerConfig.phone} />
                    </div>
                </div>
            </div>
        );
    }
}